var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"PageNotFound"}},[_vm._v("\n\t404 PAGINA NO ENCONTRADA\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }